"use strict";

const TREE_NAVIGATION_CLASS_NAME = 'js-treeNavigation';
const LOADER_CLASS_NAME = 'js-treeNavigation__ajaxLoader';
const DATA_INIT = 'data-init';
jQuery(document).ready(() => {
  const treeNavigations = document.getElementsByClassName(TREE_NAVIGATION_CLASS_NAME);
  for (let i = 0; i < treeNavigations.length; i++) {
    const treeNavigation = treeNavigations[i];
    //console.log(treeNavigation);
    initialiseTreeNavigation(treeNavigation);
  }
});

// Init the tree-navigation immediately if this script is already loaded by browser.
document.addEventListener('kvik_tree_navigation_dom_ready', function (event) {
  //console.log('kvik_tree_navigation_dom_ready', event.detail, document.getElementById(event.detail));
  initialiseTreeNavigation(document.getElementById(event.detail));
});
const initialiseTreeNavigation = treeNavigation => {
  if (treeNavigation.hasAttribute(DATA_INIT)) {
    return;
  }

  //console.log(treeNavigation);
  const classBlock = treeNavigation.getAttribute('data-class-block');
  const classModifiers = treeNavigation.getAttribute('data-class-modifiers').split(' ');
  const openerClassNameSelector = createSelectorClassName(classBlock, 'openerTemplate');
  const openerTemplate = treeNavigation.getElementsByClassName(openerClassNameSelector)[0];
  if (!openerTemplate) {
    return;
  }
  initialiseNodes(treeNavigation, openerTemplate, classBlock, classModifiers, treeNavigation.getAttribute(`data-children-api-link`));
  treeNavigation.setAttribute('data-init', 1);
};
const isNodeOpened = node => {
  return node.getAttribute('data-opened') === '1';
};
const initialiseNodes = (context, openerTemplate, classBlock, classModifiers, childrenApiLink) => {
  const nodes = context.getElementsByClassName(createSelectorClassName(classBlock, 'node', 'hasChildren'));
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    const opener = appendOpenerToNode(node, openerTemplate);
    opener.onclick = () => {
      let list = node.getElementsByTagName('ul')[0];
      const isNodeBeingOpened = !isNodeOpened(node);
      node.setAttribute('data-opened', isNodeBeingOpened ? '1' : '0');
      toggleOpener(opener);
      if (list) {
        list.style.display = isNodeBeingOpened ? 'block' : 'none';
      } else {
        opener.disabled = true;
        const ajaxLoader = document.createElement('div');
        ajaxLoader.className = LOADER_CLASS_NAME + ' ' + 'ajax-loader';
        ajaxLoader.innerHTML = km_spinner.html;
        node.appendChild(ajaxLoader);
        const nodeDataset = {
          id: node.getAttribute('data-id'),
          level: node.getAttribute('data-level'),
          vehicleType: node.getAttribute('data-vehicle-type'),
          linkingTargetId: node.getAttribute('data-linking-target-id'),
          linkingTargetType: node.getAttribute('data-linking-target-type')
        };
        fetchChildren(childrenApiLink, nodeDataset, childrenData => {
          node.removeChild(ajaxLoader);
          if (childrenData.length === 0) {
            return;
          }
          const level = parseInt(nodeDataset.level) + 1;
          list = document.createElement('ul');
          list.className = createClassName(classBlock, classModifiers, 'list', level);
          for (const childData of childrenData) {
            const hasChildren = childData['hasChildren'];
            const childNode = document.createElement('li');
            childNode.className = createClassName(classBlock, classModifiers, 'node', level, hasChildren);
            childNode.setAttribute('data-id', childData.id);
            childNode.setAttribute('data-level', level.toString());
            if (nodeDataset.linkingTargetId !== null) {
              childNode.setAttribute('data-linking-target-id', nodeDataset.linkingTargetId);
            }
            if (nodeDataset.linkingTargetType !== null) {
              childNode.setAttribute('data-linking-target-type', nodeDataset.linkingTargetType);
            }
            if (nodeDataset.vehicleType !== null) {
              childNode.setAttribute(`data-vehicle-type`, nodeDataset.vehicleType);
            }
            const childNodeAnchor = document.createElement('a');
            childNodeAnchor.href = childData.url;
            childNodeAnchor.className = createClassName(classBlock, classModifiers, 'link', level, hasChildren);
            childNode.appendChild(childNodeAnchor);
            const childNodeName = document.createElement('span');
            childNodeName.className = createClassName(classBlock, classModifiers, 'name', level, hasChildren);
            childNodeName.innerText = childData.name;
            childNodeAnchor.appendChild(childNodeName);
            if (childData.tagName) {
              const childNodeTag = document.createElement('span');
              childNodeTag.className = createClassName(classBlock, classModifiers, 'tag', level, hasChildren);
              childNodeTag.className += ' tag --category';
              childNodeTag.innerText = childData.tagName;
              childNodeAnchor.appendChild(childNodeTag);
            }
            list.appendChild(childNode);
          }
          node.appendChild(list);
          list.style.display = 'block';
          opener.disabled = false;
          initialiseNodes(list, openerTemplate, classBlock, classModifiers, childrenApiLink);
          if (window.hasOwnProperty('onChildCategoriesInitialised')) {
            window['onChildCategoriesInitialised'](list);
          }
          if (window.hasOwnProperty('updateStickySidebar')) {
            window['updateStickySidebar']();
          }
        });
      }
    };
  }
};
const createSelectorClassName = (blockName, elementName, modifierName) => {
  return blockName + (elementName ? `__${elementName}` : '') + (modifierName ? `--${modifierName}` : '');
};
const createClassName = (classBlock, classModifiers, elementName, level, hasChildren) => {
  const classBase = `${classBlock}__${elementName}`;
  let className = `${classBase}`;
  className += ` ${elementName}`; // BC

  for (let i = 0; i < classModifiers.length; i++) {
    className += ` ${classBase}--` + classModifiers[i];
  }
  if (level) {
    className += ` ${classBase}--${level.toString()}`;
    className += ` ${elementName}-${level.toString()}`; // BC
  }
  if (hasChildren) {
    className += ` ${classBase}--hasChilds`;
    className += ` ${classBase}--hasChildren`;
  }
  return className;
};
const appendOpenerToNode = (node, openerTemplate) => {
  const openerContent = document.importNode(openerTemplate.content, true);
  node.insertBefore(openerContent, node.firstChild);
  const opener = node.getElementsByTagName('button')[0];
  const toHideChildrenIndex = isNodeOpened(node) ? 0 : 1;
  $(opener.children[toHideChildrenIndex]).hide();
  node.appendChild(opener);
  return opener;
};
const toggleOpener = opener => {
  $(opener.children[0]).toggle();
  $(opener.children[1]).toggle();
};
const fetchChildren = (childrenApiLink, dataset, doOnSuccess) => {
  let params = null;
  if (childrenApiLink.includes(`_parentId_`)) {
    childrenApiLink = childrenApiLink.replace(`_parentId_`, dataset.id);
  } else {
    params = {
      ...dataset
    };
    for (const param in params) {
      if (params.hasOwnProperty(param)) {
        if (params[param] === null) {
          delete params[param];
        }
      }
    }
    params = {
      ...params
    };
  }
  jQuery.get(childrenApiLink, params).done(function (data) {
    doOnSuccess(data);
  }).error(function (error) {
    console.error(error);
  });
};